import React, { Component } from 'react';
import { baseUrl } from '../url';

class AddEditContacts extends Component{
    constructor(props){
        super(props)
        this.state = {
            contactPersons: this.props.contactPersons,
            firstPerson: {
                name: '',
                phone_no: '',
                email: '',
                address: ''
            },
            secondPerson: {
                name: '',
                phone_no: '',
                email: '',
                address: ''
            },
            first_nameError: '',
            second_nameError: '',
            first_phone_noError: '',
            second_phone_noError: '',
            first_emailError: '',
            second_emailError: '',
            first_addressError: '',
            second_addressError: '',

            message: ''
        }
        this.handleChangeFirst = this.handleChangeFirst.bind(this);
        this.handleChangeSecond = this.handleChangeSecond.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.submitContacts = this.submitContacts.bind(this);
    }
    componentDidMount(){
        let contactPersons = this.props.contactPersons;

        if(contactPersons.length > 0){
            this.setState({
                firstPerson: {
                    name: contactPersons[0].name,
                    phone_no: contactPersons[0].phone_no,
                    email: contactPersons[0].email,
                    address: contactPersons[0].address
                }
            })
        }
        if(contactPersons.length === 2){
            this.setState({
                firstPerson: {
                    name: contactPersons[0].name,
                    phone_no: contactPersons[0].phone_no,
                    email: contactPersons[0].email,
                    address: contactPersons[0].address
                },
                secondPerson: {
                    name: contactPersons[1].name,
                    phone_no: contactPersons[1].phone_no,
                    email: contactPersons[1].email,
                    address: contactPersons[1].address
                },
            })
        }
    }
    submitContacts(array){
        const token = localStorage.getItem('access_token');
        fetch(`${baseUrl}/admin/patients/contacts/${this.props.id}`,{
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({
                "contacts": array,
            })
        })
        .then((response) => {
            const auth = response.headers.get('Authorization');
            localStorage.setItem('access_token', auth);
            return response.json();
        })
        .then((responseJson) => {
            console.log(responseJson);
            if(responseJson.hasOwnProperty('_meta')){
                if(responseJson._meta._status === 202){
                    this.setState({
                        message: responseJson.message
                    })
                }
            }
        })
    }
    handleChangeFirst(e){
        e.preventDefault();
        let { firstPerson } = this.state;
        let name = e.target.name;
        let value = e.target.value;

        firstPerson[name] = value;

        this.setState({firstPerson});
        this.setState({
            ['first_' + name +'Error']:''
        });

        if(e.target.name === 'phone_no'){
            this.setState({
                first_phone_noError: ''
            })
            if(e.target.value.length >= 11){
                if(!/(0[7-9][01])\d{8}/.test(e.target.value)){
                    this.setState({
                        first_phone_noError: 'Please enter a valid phone number'
                    })
                }
            }
        }
    }
    handleChangeSecond(e){
        e.preventDefault();
        let { secondPerson } = this.state;
        let name = e.target.name;
        let value = e.target.value;

        secondPerson[name] = value;

        this.setState({secondPerson})
        this.setState({
            ['second_' + name +'Error']:''
        });
        if(e.target.name === 'phone_no'){
            this.setState({
                first_phone_noError: ''
            })
            if(e.target.value.length >= 11){
                if(!/(0[7-9][01])\d{8}/.test(e.target.value)){
                    this.setState({
                        second_phone_noError: 'Please enter a valid phone number'
                    })
                }
            }
        }
    }
    handleSubmit(e){
        e.preventDefault();
        let { 
                firstPerson, 
                secondPerson,
                first_nameError, 
                first_phone_noError, 
                first_emailError, 
                first_addressError, 
                second_nameError, 
                second_phone_noError, 
                second_emailError, 
                second_addressError 
            } = this.state;

        if(!firstPerson.name){
            this.setState({
                first_nameError: 'This field cannot be empty'
            })
        }
        if(!firstPerson.phone_no){
            this.setState({
                first_phone_noError: 'This field cannot be empty'
            })
        }
        if(!firstPerson.email){
            this.setState({
                first_emailError: 'This field cannot be empty'
            })
        }
        if(!firstPerson.address){
            this.setState({
                first_addressError: 'This field cannot be empty'
            })
        }
        
        if(secondPerson.name || secondPerson.phone_no || secondPerson.email || secondPerson.address){
            if(!secondPerson.name){
                this.setState({
                    second_nameError: 'This field cannot be empty'
                })
            }
            if(!secondPerson.phone_no){
                this.setState({
                    second_phone_noError: 'This field cannot be empty'
                })
            }
            if(!secondPerson.email){
                this.setState({
                    second_emailError: 'This field cannot be empty'
                })
            }
            if(!secondPerson.address){
                this.setState({
                    second_addressError: 'This field cannot be empty'
                })
            }
            if(secondPerson.name.toLowerCase() === firstPerson.name.toLowerCase()){
                this.setState({
                    second_nameError: "Name fields shouldn't be the same"
                })
            }
            if(secondPerson.phone_no === firstPerson.phone_no){
                this.setState({
                    second_phone_noError: "Phone fields shouldn't be the same"
                })
            }
            if(secondPerson.email.toLowerCase() === firstPerson.email.toLowerCase()){
                this.setState({
                    second_emailError: "Email fields shouldn't be the same"
                })
            }
        }
        let contactsArray = [];

        if(firstPerson.name && firstPerson.phone_no && firstPerson.email && firstPerson.address && !first_nameError && !first_phone_noError && !first_emailError && !first_addressError && !second_nameError && !second_phone_noError && !second_emailError && !second_addressError){
            contactsArray[0] = firstPerson;
            if(secondPerson.name && secondPerson.phone_no && secondPerson.email && secondPerson.address && !second_nameError && !second_phone_noError && !second_emailError && !second_addressError){
                contactsArray[1] = secondPerson;
                this.submitContacts(contactsArray);
            }else{
                this.submitContacts(contactsArray);
            }
        }
    }
    render(){
        let state = this.state;
        return(
            <div className="add-edit-contacts">
                <div className="">
                {
                    this.state.message.length > 0 &&
                    <div className="check">
                        <div className="svg-div">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                                <circle className="path circle" fill="none" stroke="#14DA9E" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
                                <polyline className="path check" fill="none" stroke="#14DA9E" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
                            </svg>
                        </div>
                        <p><small>{this.state.message}</small></p>
                    </div>
                }
                {   
                    this.state.message.length === 0 &&
                    <form onSubmit={this.handleSubmit}>
                        <h3>one or two contact persons</h3>
                        <div className="row">
                            <div className="col-sm-6">
                                <label className="section-title">Contact Person 1</label>
                                <label>
                                    Name
                                    <input type="text" value={state.firstPerson.name} name="name" onChange={this.handleChangeFirst} className={this.state.first_nameError && 'error-input'}/>
                                    <span className="error-text">{this.state.first_nameError}</span>
                                </label>
                                <label>
                                    Phone Number
                                    <input type="text" value={state.firstPerson.phone_no} name="phone_no" onChange={this.handleChangeFirst} className={this.state.first_phone_noError && 'error-input'}/>
                                    <span className="error-text">{this.state.first_phone_noError}</span>
                                </label>
                                <label>
                                    Email
                                    <input type="email" value={state.firstPerson.email} name="email" onChange={this.handleChangeFirst} className={this.state.first_emailError && 'error-input'}/>
                                    <span className="error-text">{this.state.first_emailError}</span>
                                </label>
                                <label>
                                    Address
                                    <input type="text" value={state.firstPerson.address} name="address" onChange={this.handleChangeFirst} className={this.state.first_addressError && 'error-input'}/>
                                    <span className="error-text">{this.state.first_addressError}</span>
                                </label>
                            </div>
                            <div className="col-sm-6">
                                <label className="section-title">Contact Person 2</label>
                                <label>
                                    Name
                                    <input type="text" value={state.secondPerson.name} name="name" onChange={this.handleChangeSecond} className={this.state.second_nameError && 'error-input'}/>
                                    <span className="error-text">{this.state.second_nameError}</span>
                                </label>
                                <label>
                                    Phone Number
                                    <input type="tel" value={state.secondPerson.phone_no} name="phone_no" onChange={this.handleChangeSecond} className={this.state.second_phone_noError && 'error-input'}/>
                                    <span className="error-text">{this.state.second_phone_noError}</span>
                                </label>
                                <label>
                                    Email
                                    <input type="email" value={state.secondPerson.email} name="email" onChange={this.handleChangeSecond} className={this.state.second_emailError && 'error-input'}/>
                                    <span className="error-text">{this.state.second_emailError}</span>
                                </label>
                                <label>
                                    Address
                                    <input type="text" value={state.secondPerson.address}  name="address" onChange={this.handleChangeSecond} className={this.state.second_addressError && 'error-input'}/>
                                    <span className="error-text">{this.state.second_addressError}</span>
                                </label>
                            </div>
                        </div>
                        <div className="button-div">
                            <button className="button" type="button" onClick={this.props.handleClose}>Cancel</button>
                            <button type="submit">Save</button>
                        </div>
                    </form>
                }
                </div>
            </div>
        )
    }
}

export default AddEditContacts;


// WEBPACK FOOTER //
// ./src/components/patientProfile/AddEditContacts.js